/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectRssIcon16Regular = forwardRef('NetConnectRssIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.754 4.756a7.75 7.75 0 0 0-3.21-.493.75.75 0 0 1-.088-1.497 9.25 9.25 0 0 1 9.778 9.78.75.75 0 1 1-1.497-.088 7.751 7.751 0 0 0-4.983-7.702Z" }),
        React.createElement("path", { d: "M5.24 8.461a3.75 3.75 0 0 0-1.659-.188.75.75 0 0 1-.167-1.49 5.25 5.25 0 0 1 5.802 5.812.75.75 0 1 1-1.49-.17A3.75 3.75 0 0 0 5.24 8.461Z" }),
        React.createElement("path", { d: "M4 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
